var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"full-width-image content-section"},[_c('prismic-image',{attrs:{"field":_vm.slice.primary.image}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }